import React from 'react'

import WellExplorer from './wells/Explorer'
import SampleExplorer from './samples/Explorer'
import Map from './map/Map'
import WellDetail from './wellDetail/Detail'
import Aggregate from './aggregate/Aggregate'
import BoxPlot from './box-plot/BoxPlot'
import Piper from './piper/Piper'

export default () => (
    <div className="spaWrapper">
        <WellDetail />
        <div className="columns spaContainer is-full is-multiline is-1 is-variable">
            <div className="column is-one-third-desktop is-full-tablet is-full-mobile">
                <SampleExplorer width={'one-third'} />
                <Aggregate width={'one-third'} />
            </div>
            <div className="column is-two-thirds-desktop is-full-tablet is-full-mobile">
                <Map width={'full'} />
                <WellExplorer width={'full'} />
                <BoxPlot width={'full'} />
                <Piper width={'full'} />
            </div>
        </div>
    </div>
)
